module.exports = __webpack_public_path__ + "static/Vue.ai-5750b899639edd77393c3ef6dba2b91b.svg";